import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import AgendaFileCard from "../Card/AgendaFileCard";
import { useSelector } from "react-redux";



function AgendaFileDialog({ onClose, open, agendaFileList, setAgendaFileList }) {


    const fontSettings = useSelector((state) => state.meeting.fontSettings);
    const { baseFontSize, titleFontSize } = fontSettings;

    return (
        <Dialog onClose={onClose} open={open} fullWidth maxWidth="md">
            <DialogTitle sx={{ fontSize: titleFontSize }}>
                {'Dosya İşlemleri (' + agendaFileList.length + ' Dosya)'}
            </DialogTitle>

            <DialogContent dividers sx={{ fontSize: titleFontSize }}>
                <AgendaFileCard
                    agendaFileList={agendaFileList}
                    setAgendaFileList={setAgendaFileList}
                    onClose={onClose}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    size='small'
                    color="error"
                    onClick={onClose}
                    sx={{ fontSize: baseFontSize }}
                >
                    Kapat
                </Button>
            </DialogActions>
        </Dialog>
    );
}
export default AgendaFileDialog;



